import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin.service'

@Component({
  selector: 'app-send',
  templateUrl: './send.component.html',
  styleUrls: ['./send.component.scss']
})
export class SendComponent implements OnInit {

  constructor(private adminServer: AdminService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/email/send/send.component.ts